<template>
  <section class="dbc-gl-section" v-bind="!isWebview() ? aos : null">
    <slot />
  </section>
</template>

<script setup lang="ts">
const props = defineProps<{
  aos?: Aos
}>()

const aos = {
  'data-aos': props.aos?.fadeDirection,
  'data-aos-delay': props.aos?.delay,
}
</script>
